import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_BACKEND_API_URL ||
  "http://localhost:4200/api/v1";

export const AuthInterceptor = async (url, options = {}) => {
  const token = localStorage.getItem("token");
  const hasBody = options.body !== undefined && options.body !== null;

  // default headers
  let headers = { ...options.headers };

  // only add JSON header if body is not FormData
  if (hasBody && !(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  if (!url.includes("/admin/auth/login") && token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  try {
    const response = await axios({
      url: `${BASE_URL}${url}`,
      method: options.method || "GET",
      headers,
      data: hasBody ? options.body : undefined,
      validateStatus: () => true,
    });

    if (response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return response;
  } catch (error) {
    console.error("Network error:", error.message);
    return { status: 500, data: { message: "Network error" } };
  }
};
